import { User, LoginCredentials, AuthResponse } from '@/types'
import { API_BASE_URL, getAuthHeaders, withRetry, handleResponse, apiRequestWithAutoRefresh } from '../utils/apiUtils'

export const authService = {
  // Login user
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    return withRetry(async () => {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials)
      })

      const result = await handleResponse(response)
      return result.data
    })
  },

  // Get current user
  async getCurrentUser(): Promise<User> {
    return withRetry(async () => {
      const response = await fetch(`${API_BASE_URL}/auth/me`, {
        method: 'GET',
        headers: getAuthHeaders()
      })

      const result = await handleResponse(response)
      return result.data
    })
  },

  // Update user profile
  async updateProfile(userData: Partial<User>): Promise<User> {
    const result = await apiRequestWithAutoRefresh('/auth/profile', {
      method: 'PUT',
      body: JSON.stringify(userData)
    })
    return result.data
  },

  // Update bank information
  async updateBankInfo(bankInfo: any): Promise<User> {
    const result = await apiRequestWithAutoRefresh('/auth/bank-info', {
      method: 'PUT',
      body: JSON.stringify(bankInfo)
    })
    return result.data
  },

  // Change password
  async changePassword(data: { currentPassword: string; newPassword: string }): Promise<void> {
    await apiRequestWithAutoRefresh('/auth/change-password', {
      method: 'PUT',
      body: JSON.stringify(data)
    })
  },

  // Logout (if needed for server-side logout)
  async logout(): Promise<void> {
    await apiRequestWithAutoRefresh('/auth/logout', {
      method: 'POST'
    })
  },

  // Refresh token
  async refreshToken(): Promise<AuthResponse> {
    const refreshToken = localStorage.getItem('refreshToken')
    
    if (!refreshToken) {
      throw new Error('No refresh token available')
    }

    return withRetry(async () => {
      const response = await fetch(`${API_BASE_URL}/auth/refresh`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ refreshToken })
      })

      const result = await handleResponse(response)
      return result.data
    })
  },
}

export default authService
